import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretDownLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 8.03546L12 16.0355L4 8.03546", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretDownLarge);
const Memo = memo(ForwardRef);
export default Memo;
